const desktop = theme => {
  const {toVW} = theme;

  return {};
};

const mobile = theme => {
  const {toVW} = theme;
  return {
    cellBorder: {
      background:
        'linear-gradient(155.28deg, #CC7DCC 0%, #0B0910 33.33%, #0B0910 66.67%, #632D92 100%)',
      boxShadow: '0px 0px 5px rgba(205, 125, 204, 0.3)',
      padding: 1,
      borderRadius: '10px',
    },
    emojiGridCell: {
      background: '#272D39',
      cursor: 'pointer',
      padding: '3px 10px !important',
      display: 'flex',
      justifyContent: 'space-evenly',
      flexDirection: 'column',
      alignItems: 'center',
      borderRadius: 9,
      maxWidth: '100%',
      height: 124,
    },
    amountArea: {
      background: '#202633',
      height: 28,
      borderRadius: 10,
      width: '100%',
      fontSize: 12,
      fontWeight: 500,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: theme.secondaryColor,
      boxShadow: 'inset 0px 4px 10px 0px rgba(0, 0, 0, 0.25)',
    },

    priceSection: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },
    freeEmoji: {
      color: 'white',
    },
    diamondImage: {
      marginRight: '5px',
      height: '19px',
      zIndex: '1',
    },
    priceTag: {
      fontSize: 14,
      fontWeight: 700,
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
